// extracted by mini-css-extract-plugin
export var chevronIcon = "_49-2";
export var teamName = "_49-1";
export var teamSwitcherButton = "_49-0";